import PropTypes from 'prop-types';

import { evisortBlue } from '../../../assets/shared-styles/general';

const SubArrowIcon = ({
  size = '24',
  color = '#fff',
  opacity = '1',
  isActive,
}) => {
  const iconColor = isActive ? evisortBlue : color;
  const iconOpacity = isActive ? '1' : opacity;

  return (
    <svg width={size} height={size} viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path
          fill={iconColor}
          fillOpacity={iconOpacity}
          fillRule="nonzero"
          d="M18.29 15.71l-4.58 4.58c-.39.39-1.03.39-1.42 0-.39-.39-.39-1.03 0-1.42L15.17 16H5c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v9h9.17l-2.88-2.87c-.39-.39-.39-1.03 0-1.42.39-.39 1.03-.39 1.42 0l4.58 4.58c.39.39.39 1.03 0 1.42z"
        />
      </g>
    </svg>
  );
};

SubArrowIcon.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
  opacity: PropTypes.string,
  isActive: PropTypes.bool,
};

export default SubArrowIcon;
